import formatNumber from 'legacy/modules/common/components/MNumeric/formatNumber';
import MTableCellNameIcon from 'components/seller/campaings/MTableCellNameIcon.vue';
import MTableCellText from 'components/seller/campaings/MTableCellText.vue';
import MTableCellPeriodPerformance from 'components/seller/performance/MTableCellPeriodPerformance.vue';
import MTableCellMetricPerformance from 'components/seller/performance/MTableCellMetricPerformance.vue';
import {HYPHEN_MINUS, MINUS_SIGN, PLUS_SIGN} from 'appConstants';
import sellerStore from 'store/indexSeller';

const isZero = (metric) => [0, '0', 0.0, null, undefined, '-'].includes(metric);

const revertSign = (value) => {
  if (value.includes(MINUS_SIGN)) {
    return value.replace(MINUS_SIGN, PLUS_SIGN);
  } else if (value.includes(PLUS_SIGN)) {
    return value.replace(PLUS_SIGN, MINUS_SIGN);
  }
  return value;
};

const rulesForGenerateMetric = (allowShowKeysMetrics = null) => {
  const RULE_METRICS = [
    {
      id: 'profit',
      name: 'Общая выгода',
      isPositiveGrowth: true,
      type: 'currency',

      header: 'Общая выгода, ₽',
      sortable: false,
      firstSortDir: 'desc',
      minWidth: 138,
      align: 'right'
    },
    {
      id: 'save',
      name: 'Вы сэкономили',
      isPositiveGrowth: false,
      type: 'currency',
      revertSign: true,

      header: 'Вы сэкономили, ₽',
      sortable: false,
      firstSortDir: 'desc',
      minWidth: 147,
      align: 'right'
    },
    {
      id: 'earn',
      name: 'Вы заработали',
      isPositiveGrowth: true,
      type: 'currency',

      header: 'Вы заработали, ₽',
      sortable: false,
      firstSortDir: 'desc',
      minWidth: 141,
      align: 'right'
    },
    {
      id: 'crr',
      name: 'ДРР',
      isPositiveGrowth: false,
      type: 'percent',

      header: 'ДРР',
      sortable: false,
      firstSortDir: 'desc',
      minWidth: 78,
      align: 'right'
    },
    {
      id: 'orders',
      name: 'Заказы',
      isPositiveGrowth: true,
      type: 'integer',

      header: 'Заказы',
      sortable: false,
      firstSortDir: 'desc',
      minWidth: 86,
      align: 'right'
    }
  ];

  if (allowShowKeysMetrics !== null) {
    if (allowShowKeysMetrics.length < 2) {
      return [];
    }

    return RULE_METRICS.filter(rule => allowShowKeysMetrics.includes(rule.id));
  }

  return RULE_METRICS;
};

const getMetricsColumn = (allowShowKeysMetrics) => rulesForGenerateMetric(allowShowKeysMetrics).map(rule => ({
  ...rule,
  itemKey: rule.id,
  cellComponent: MTableCellMetricPerformance
}));

const addPlusSignIfPositive = (rawValue, formattedValue) => {
  const numeric = Number(rawValue);
  if (!Number.isNaN(numeric) && numeric > 0) {
    return `+${formattedValue}`;
  }
  return formattedValue;
};

export const getSellerBidderPerformanceTableColumns = (allowShowKeysMetrics) => [
  {
    itemKey: 'campaign_name',
    channelKey: 'channel_id',
    header: 'Рекламная кампания',
    cellComponent: MTableCellNameIcon,
    minWidth: 230,
    align: 'left',
    static: true,
    sortable: false
  },
  {
    itemKey: 'campaign_id',
    header: 'ID кампании',
    cellComponent: MTableCellText,
    minWidth: 110,
    align: 'left',
    sortable: false,
    firstSortDir: 'desc',
    textColor: '#A8A8A8'
  },
  {
    itemKey: 'period',
    header: 'Период',
    cellComponent: MTableCellPeriodPerformance,
    minWidth: 91,
    align: 'left',
    sortable: false
  },
  ...getMetricsColumn(allowShowKeysMetrics)
];

export const getComputedSummaryBidderPerformance = (
  summaryBidderPerformance,
  fromPerformanceDetail = false,
  allowShowKeysMetrics = []
) => {
  if (!summaryBidderPerformance || !allowShowKeysMetrics.length || allowShowKeysMetrics.length < 2) {
    return null;
  }

  const resultMetrics = summaryBidderPerformance.metrics;
  const metrics = [];

  rulesForGenerateMetric(allowShowKeysMetrics).forEach(rule => {
    const metric = resultMetrics[rule.id];

    if (metric !== undefined) {
      let options = {};
      if (rule.type === 'currency') {
        if (!fromPerformanceDetail) {
          options.decimalPlaces = 0;
          options.withCurrencySymbol = true;
        }

        options.vat = sellerStore.getters['sellerUser/vatDivider'];
      }

      if (rule.type === 'percent') {
        options.allowDecimalPadding = fromPerformanceDetail || metric % 1 !== 0;
      }
      const formatted = formatNumber(metric, rule.type, options);
      const valueWithSign = addPlusSignIfPositive(metric, formatted).replace(HYPHEN_MINUS, MINUS_SIGN);

      let value = valueWithSign;
      if (rule.revertSign) {
        value = revertSign(value);
      }

      metrics.push({
        ...rule,
        value,
        isZero: isZero(metric),
        isPositive: metric > 0
      });
    }
  });

  if (metrics.length === 0) {
    return null;
  }

  return metrics;
};

export const getComputedPlacementsBidderPerformance = (
  placementsBidderPerformance,
  summaryBidderPerformance,
  allowShowKeysMetrics
) => {
  if (
    !placementsBidderPerformance ||
    !placementsBidderPerformance.length ||
    !summaryBidderPerformance ||
    allowShowKeysMetrics.length < 2
  ) {
    return null;
  }

  const summaryMetrics = {
    isSummaryCell: true,
    metrics: Object.fromEntries(
      getComputedSummaryBidderPerformance(
        summaryBidderPerformance,
        true,
        allowShowKeysMetrics
      ).map(item => [item.id, item])
    )
  };

  const resultGeneratedMetrics = placementsBidderPerformance.map(item => {
    let resultMetrics = item.metrics;
    let metrics = {};

    rulesForGenerateMetric(allowShowKeysMetrics).forEach(rule => {
      const metric = resultMetrics[rule.id];

      if (metric !== undefined) {
        let options = {
          withCurrencySymbol: false
        };

        if (rule.type === 'percent') {
          options.allowDecimalPadding = true;
        }

        if (rule.type === 'currency') {
          options.vat = sellerStore.getters['sellerUser/vatDivider'];
        }

        const formatted = formatNumber(metric, rule.type, options);
        const valueWithSign = addPlusSignIfPositive(metric, formatted).replace(HYPHEN_MINUS, MINUS_SIGN);

        let value = valueWithSign;
        if (rule.revertSign) {
          value = revertSign(value);
        }

        metrics[rule.id] = {
          isPositive: metric > 0,
          isZero: isZero(metric),
          value
        };
      }
    });

    resultMetrics = {
      ...item,
      metrics
    };

    return resultMetrics;
  });

  return [summaryMetrics, ...resultGeneratedMetrics];
};

export const getPositivePerformanceKeysMetrics = (summaryBidderPerformance) => {
  const metrics = summaryBidderPerformance?.metrics;

  if (!metrics) {
    return [];
  }

  const resultPositiveKeysMetrics = [];

  rulesForGenerateMetric(null).forEach(rule => {
    const metric = metrics[rule.id];
    if (metric) {
      const isPositiveResult = rule.isPositiveGrowth ? metric > 0 : metric < 0;
      if (isPositiveResult) {
        resultPositiveKeysMetrics.push(rule.id);
      }
    }
  });

  return resultPositiveKeysMetrics;
};
